import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || "https://pjkbsydbxubouotfokfy.supabase.co";
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBqa2JzeWRieHVib3VvdGZva2Z5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzczOTI3OTgsImV4cCI6MjA5Mjk2ODc5OH0.vOKMU0az7CW3yhGXUFDFK1z6J8QkD91J5nmB2-h5VEA";

export const supabaseAuth = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
export { SUPABASE_URL, SUPABASE_ANON_KEY };
